import api from '@/api';

function hasProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export default {
  namespaced: true,

  state: {
    data: [],
    currentItem: {},
  },

  getters: {
    //
  },

  mutations: {
    setData(state, data) {
      state.data = data;
    },

    setCurrentItem(state, data) {
      state.currentItem = Object.assign({}, data);
    },
  },

  actions: {
    list({ commit, state }) {
      commit('setData', []);

      api()
        .get('/collaboration/questions')
        .then((response) => {
          commit('setData', response.data.data.question);
        })
        .catch((error) => {
          if (error.response && hasProp(error.response.data.data, 'question')) {
            commit('setData', error.response.data.data.question);
          }
        });
    },

    read({ commit, state }, itemId) {
      commit('setCurrentItem', {});

      api()
        .get(`/collaboration/question/${itemId}`)
        .then((response) => {
          commit('setCurrentItem', response.data.data.question[0]);
        })
        .catch((error) => {
          if (error.response && hasProp(error.response.data.data, 'question')) {
            commit('setCurrentItem', error.response.data.data.question[0]);
          }
        });
    },
  },
};
